import { FormItem } from '@eastcoal/formily/components/FormItem'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { KindRootNodeCheckbox } from '@eastcoal/shared/@formily/KindRootNodeCheckbox'

export const kindSchema: Record<string, SchemaItem> = {
  kinds: {
    type: 'array',
    'x-decorator': FormItem,
    'x-decorator-props': {
      wrapperWidth: 'auto'
    },
    'x-component': KindRootNodeCheckbox,
    'x-component-props': {
      multiple: true
    },
    'x-validator': [
      {
        required: true,
        message: '交易意向品类不能为空'
      }
    ]
  }
}
